module.exports = __webpack_public_path__ + "img/shop-similar-photo-search.ed9e1d8.png";